<ng-container *ngIf="isDevMode()">
  <app-test-harness></app-test-harness>
</ng-container>
<header app-header></header>
<main>
<router-outlet></router-outlet>
</main>
<footer app-footer></footer>
